var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","align":"center"}},[_c('div',{staticClass:"py-5 fadeInUp",attrs:{"id":"about-container"},domProps:{"innerHTML":_vm._s(_vm.getAboutContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }